var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvideSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 488,
    viewBox: "0 0 512 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.76 48.0312H329.401M363.739 48.0312H366.38M400.718 48.0312H403.359M45.453 48.0312H48.094M451.757 353.651L408.423 406.731L381.757 376.288M294.667 312.688H234.812M234.812 354.311H294.667M234.812 240.187H395.579M234.812 197.689H395.579M234.812 155.191H395.579M234.812 395.934H294.667",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.058 385.004C329.514 399.463 333.653 413.565 341.082 425.978C348.511 438.39 358.986 448.701 371.513 455.934L411.756 479.169C413.276 480.046 415.001 480.508 416.756 480.508C418.511 480.508 420.236 480.046 421.756 479.169L462 455.934C474.922 448.474 485.652 437.744 493.112 424.822C500.572 411.9 504.5 397.243 504.5 382.322V335.853C504.5 334.098 504.038 332.373 503.16 330.853C502.283 329.333 501.02 328.071 499.5 327.193L421.757 282.308C420.237 281.43 418.512 280.969 416.757 280.969C415.002 280.969 413.277 281.43 411.757 282.308L334.014 327.193C332.494 328.071 331.231 329.333 330.354 330.853C329.476 332.373 329.014 334.098 329.014 335.853V350.004M104 7.5H22.5C14.216 7.5 7.5 14.216 7.5 22.5V88.561H441.312V22.5C441.312 14.216 434.596 7.5 426.312 7.5H139M441.312 293.598V190.004",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M441.312 155.006V88.5625H7.5V427.841C7.5 436.125 14.216 442.841 22.5 442.841H354.336",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.628 275.598H68.233C59.949 275.598 53.233 268.882 53.233 260.598V229.119C53.233 211.76 67.306 197.688 84.665 197.688H160.196C177.555 197.688 191.628 211.76 191.628 229.119V260.598C191.628 268.883 184.913 275.598 176.628 275.598Z",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.431 197.689C143.946 197.689 161.387 180.248 161.387 158.733C161.387 137.219 143.946 119.777 122.431 119.777C100.916 119.777 83.475 137.219 83.475 158.733C83.475 180.248 100.916 197.689 122.431 197.689Z",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.777 312.688H63.085C57.644 312.688 53.234 317.099 53.234 322.539V354.31H191.629V322.539C191.628 317.098 187.218 312.688 181.777 312.688Z",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.628 354.309H53.233V386.08C53.233 391.521 57.644 395.931 63.084 395.931H181.776C187.217 395.931 191.627 391.52 191.627 386.08V354.309H191.628Z",
    stroke: "#B29100",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvideSecure);
export default __webpack_public_path__ + "static/media/ProvideSecure.14d95540f4e12273612fa5f303318383.svg";
export { ForwardRef as ReactComponent };